import React from 'react'
import Slider, { Settings } from 'react-slick'

import { Collections_collections } from './_gql-types/Collections'

import styles from './CollectionBanner.module.scss'

interface Props {
  collections?: Collections_collections | null
}

export default function CollectionBanner({collections}: Props) {
  const settings: Settings = {
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    swipeToSlide: true,
    autoplaySpeed: 6000,
  }

  if (!collections) return null

  return (
    <Slider {...settings}>
      {collections.edges.map(collection => !!collection.node.backgroundImage?.url && (
        <div key={collection.node.id} className={styles.BannerItem}>
          <div
            className={styles.BannerItemImage}
            style={{backgroundImage: `url(${collection.node.backgroundImage.url})`}}
          />
        </div>
      ))}
    </Slider>
  )
}
